import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ILevel, ILevels } from '../interfaces/level';

@Injectable({
  providedIn: 'root',
})
export class LevelService {
  constructor(private httpClient: HttpClient) {}

  getLevels(url: string, filters: any): Observable<ILevels> {
    return this.httpClient.get<ILevels>(url, {
      headers: { accept: '*/*' },
      params: filters,
    }) as Observable<ILevels>;
  }

  getLevelById(url: string): Observable<ILevel> {
    return this.httpClient.get<ILevel>(url, { headers: { accept: '*/*' } }) as Observable<ILevel>;
  }

  editLevel(url: string, levelForm: any): Observable<ILevel> {
    return this.httpClient.patch<ILevel>(url, levelForm, {
      headers: { accept: '*/*' },
    }) as Observable<ILevel>;
  }

  createLevel(url: string, levelForm: any): Observable<ILevel> {
    return this.httpClient.post<ILevel>(url, levelForm, {
      headers: { accept: '*/*' },
    }) as Observable<ILevel>;
  }
}
